import { AbstractControl, ControlValueAccessor, ValidationErrors, Validator } from '@angular/forms';

export abstract class BaseControlValueAccessor<T> implements ControlValueAccessor, Validator {
  protected onChange = (value: T) => {};
  protected onTouched = () => {};

  abstract writeValue(value: T): void;

  registerOnChange(fn: (value: T) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  abstract setDisabledState?(isDisabled: boolean): void;

  validate(c: AbstractControl): ValidationErrors | null {
    return null;
  }
}
